











































import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput } from '@folky-tools/mdbvue';
import EditAddress from './EditAddress.vue';
import { ContactDetails } from '@/models/common/contact-details';
import { is_email_valid as isEmailValid } from 'node-email-validation';
import { email } from 'vuelidate/lib/validators';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        EditAddress
    },
    validations: {
        contactDetails: {
            phone: {
                isValid: (value): boolean => {
                    if (typeof value === 'undefined' || value === null || value === '') {
                        return true;
                    }
                    return /^\d{9}$/.test(value);
                }
            },
            phoneTwo: {
                isValid: (value): boolean => {
                    if (typeof value === 'undefined' || value === null || value === '') {
                        return true;
                    }
                    return /^\d{9}$/.test(value);
                }
            },
            email: {
                email,
                customEmail: async (value, model) => {
                    if (typeof value === 'undefined' || value === null || value === '') {
                        return true;
                    }
                    return isEmailValid(value);
                }
            }
        }
    }
})
export default class EditContactDetails extends Vue {
    @Prop(ContactDetails) private contactDetails!: ContactDetails;

    private hasErrors(): boolean {
        this.$v.contactDetails.$touch();
        if (this.$v.contactDetails.$anyError) {
            return true;
        }
        return false;
    }
}
